<template>
  <el-container class="full-height">
    <el-container>
        <el-row type="flex" justify="center" class="pt-10">
          <el-col :xs="22" :sm="20" :md="14" :lg="10" :xl="7" style="display: flex; justify-content: center;">
          <el-image
            v-if="signupCompany"
            :style="{
              height: 'auto',
              maxHeight: '140px',
              objectFit: 'contain',
              display: 'block',
              margin: '0 auto',
            }"
            :src="require(`@/assets/img/svg/register_banner_companies.svg`)"
            alt="Aliaddo"
          ></el-image>
            <el-image
              v-if="signupStudents"
              fit="cover"
              :src="require(`@/assets/img/svg/register_banner_students.svg`)"
              alt="Aliaddo"
              style="width: 100%"
            ></el-image>
          </el-col>
        </el-row>
      <el-main style="padding: 0; margin: 0">
        <el-row type="flex" justify="center">
          <el-col :span="24">
            <router-view />
          </el-col>
        </el-row>
      </el-main>
      <el-footer class="pt-5" style="background-color: #f1f1f1; font-size: 12px; height: 61px">
        <el-row type="flex" justify="center" align="middle">
          <el-col :xs="22" :sm="20" :md="14" :lg="10" :xl="7">
            <div class="text-center">
              {{ $tc('copyright') }}
            </div>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-col :xs="22" :sm="20" :md="14" :lg="10" :xl="7">
            <div class="text-center">
              <el-link href="https://aliaddo.com/blog" target="_blank" rel="noopener noreferrer">
                {{ $tc('blog') }}
              </el-link>
              &nbsp;-&nbsp;
              <el-link
                href="https://www.facebook.com/aliaddo.co"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="fab fa-facebook"></i>
              </el-link>
              &nbsp;-&nbsp;
              <el-link href="https://twitter.com/aliaddo_co" target="_blank" rel="noopener noreferrer">
                <i class="fab fa-twitter"></i>
              </el-link>
              &nbsp;-&nbsp;
              <el-link
                href="https://www.instagram.com/aliaddo.co"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="fab fa-instagram"></i>
              </el-link>
            </div>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </el-container>
</template>
<script>
export default {
  name: 'SignupLayout',
  data() {
    return {
      loading: {
        service: false,
      },
      model: {
        service: {
          serviceDomain: '',
        },
      },
    }
  },
  computed: {
    crmParams: _this => {
      if (_this.$route.query.product) {
        return _this.$route.query.product.split('-')
      }

      return []
    },
    signupCompany: _this => _this.$route.name === 'RegisterCompanies',
    signupStudents: _this => _this.$route.name === 'RegisterStudents',
    product: _this => {
      if (_this.$route.query.product && _this.$route.query.plan) {
        return _this.$route.query.product.toLowerCase()
      }
      if (_this.crmParams.length > 0) {
        return _this.crmParams[0].trim().toLowerCase()
      }

      return ''
    },
    service: _this => {
      if (_this.$route.query.product && _this.$route.query.plan) {
        return _this.$route.query.product.toLowerCase()
      }
      if (_this.crmParams.length > 0) {
        return _this.crmParams[0].trim().toLowerCase()
      }

      return ''
    },
    planName: _this => {
      if (_this.$route.query.plan) {
        return _this.$route.query.plan
      }
      if (_this.crmParams.length > 1) {
        return _this.crmParams[1].trim()
      }

      return ''
    },
    periodicidad: _this => {
      if (_this.$route.query.periodicidad) {
        return _this.$route.query.periodicidad
      }
      if (_this.crmParams.length > 2) {
        return _this.crmParams[2].trim()
      }

      return ''
    },
    serviceId: _this => {
      if (_this.product === 'fe') {
        return 1
      }
      if (_this.product === 'aliaddo') {
        return 2
      }
      if (_this.product === 'aliaddopos') {
        return 8
      }
      if (_this.product === 'isv') {
        return 7
      }
      if (_this.product === 'nomina-full') {
        return 10
      }
      if (_this.product === 'nomina-lite') {
        return 11
      }
      if (_this.product === 'nomina-isv') {
        return 12
      }
      if (_this.product === 'nomina-desk') {
        return 13
      }

      return -1
    },
  },
  created() {
    this.getService()
  },
  methods: {
    onGoToService() {
      window.open(`https://${this.model.service.serviceDomain}`, '_blank')
    },
    getService() {
      const _this = this

      _this.loading.service = true

      _this.$http
        .get(`services/${_this.serviceId}`)
        .then(response => (_this.model.service = response.data))
        .finally(() => (_this.loading.service = false))
    },
  },
}
</script>
<style lang="scss" scoped>
main.el-main:first-child {
  padding: 0px;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.el-container .pattern-gradient-dark {
  background-image: url('../assets/img/background-cover.jpg'),
    linear-gradient(rgba(36, 150, 208, 0.9), rgb(208, 245, 255));
  background-size: 1440px, 100%;
  background-size: cover;
}

/* Asegurar que el contenido principal no tenga scroll */
main.el-main:first-child > .el-row {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Asegurar que el footer no afecte el layout */
.el-footer {
  flex-shrink: 0;
}

/* footer
-------------------------------------------------- */
.service-account {
  padding: 15px 20px;
  text-align: right;

  .sub {
    color: #aaa;
    text-align: right;
    margin: 20px 20px;
  }
}

/* End of footer
-------------------------------------------------- */
</style>
